import { render, staticRenderFns } from "./ColorButton.vue?vue&type=template&id=1cc8b998&"
import script from "./ColorButton.vue?vue&type=script&lang=js&"
export * from "./ColorButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports